export default __webpack_public_path__ + "static/l1-contentOne-img-woman-0ca54181d37db0135529fc3b347bd97c.png";